import React from "react";
import { Step0, Step1, Step2, Step3, Step4 } from "./StepComponents";

const StepManager = ({ currentStep = 0, stepLabels = [], formData = {}, setFormData = () => {}, onNext = () => {}, onPrev = () => {}, onSubmit = () => {} }) => {
  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <Step0 onNext={onNext} />;
      case 1:
        return <Step1 stepLabels={stepLabels} onNext={onNext} onPrev={onPrev} formData={formData} setFormData={setFormData} />;
      case 2:
        return <Step2 stepLabels={stepLabels} onNext={onNext} onPrev={onPrev} formData={formData} setFormData={setFormData} />;
      case 3:
        return <Step3 stepLabels={stepLabels} onSubmit={onSubmit} onNext={onNext} onPrev={onPrev} formData={formData} setFormData={setFormData} />;
      case 4:
        return <Step4 stepLabels={stepLabels} onPrev={onPrev} onSubmit={onSubmit} formData={formData} />;
      default:
        return <Step0 onNext={onNext} />;
    }
  };
  return renderStep();
};

export default StepManager;
